module.exports = __webpack_public_path__ + "static/media/S1_00026.e93ce97b.jpg";